import { CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from '@mui/material'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import { ArrowBack } from '@mui/icons-material'
import MaterialTypography from '../../../components/MaterialTypography'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useSnackbar } from '../../../context/popup'
import { useLoading } from '../../../components/Loading'
import MaterialInput from '../../../components/MaterialInput'
import { useApiCategoryFormHandling } from "./components/ApiCategoryStateHandle.js";
import MaterialSelect from '../../../components/MasterSelect/index.js'
import { useEffect, useState } from 'react'
import MaterialBox from '../../../components/MaterialBox/index.js'
import MaterialButton from '../../../components/MaterialButton/index.js'
import { fetchData, postData, putData } from '../../../services/index.js'

const ApiCategoryForm = () => {

  const [searchParams] = useSearchParams();
  const apiCategoryId = searchParams.get("id");
  const pageType = searchParams.get("pageType");
  const pageMode = pageType === "view" ? "view" : pageType === "edit" ? "edit" : "add";
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();

  const [parentKeyDropOptions, setParentKeyDropOptions] = useState([]);

  useEffect(() => {
      if(pageMode === "view"){
          return
      }
      fetchParentKeyData();
  }, []);

  const fetchParentKeyData = async () => {
      setCircleLoading(true);
      try{
          const response = await fetchData(`/api-engine/key-value-category?dropdown=true&isActive=true`);            
          if(response?.success){
              const formattedCategories = response?.data?.items?.map((item) => ({
                  value: item?.id,
                  label: item?.categoryName,
              })) || [];
              setParentKeyDropOptions(formattedCategories);
          }
      }
      catch(error){
          console.error("Error Fetching Pareny Key Data:",error);
          showSnackbar("Error Fetching Parent Key Data","warning");
      }
      finally{
          setCircleLoading(false);
      }
  };

  //post and put api function
  const handleSubmitApiCategory = async () => {
    const payload = {
        code: formData?.code,
        categoryName: formData?.categoryName,
        description: formData?.description,
        parentCategoryId: formData?.parentCategoryId?.value,
        isActive: formData?.isActive
    };
    //Update
    if(apiCategoryId){
        setCircleLoading(true);
        try {
            const response = await putData(`/api-engine/key-value-category/${apiCategoryId}`, payload);
            console.log("putresponse",response);
            
            const responseMessage = response?.message;
            if(response?.success){
            //success message
                showSnackbar(responseMessage, "success");
                navigate('/api-integration-engine/key-value-category');          
            }
            else{
                //error message
                showSnackbar(responseMessage, "error")
            }
        } catch (error) {
            console.error('Error updating data:', error);
            showSnackbar("Error Updating Body Type","error");
        }
        finally{
            setCircleLoading(false);
        }
    }
    else{      
    //Submit
        setCircleLoading(true);
        try {
            const response = await postData('/api-engine/key-value-category', payload);                
            
            const responseMessage = response?.message;
            if(response?.success){
                //success message
                showSnackbar(responseMessage, "success");
                navigate('/api-integration-engine/key-value-category');          
            }
            else{
                //error message
                showSnackbar(responseMessage, "error");
            }
        } catch (error) {
            //catch error message
            console.error('Error posting data:', error);
            showSnackbar(error?.response?.data?.message,"error")
        }
        finally{
            setCircleLoading(false);
        }
    }
  };
  const { formData, setFormData, handleChange, checkAllFields } = useApiCategoryFormHandling(); 

  return (
    <DashboardLayout>
        <CardHeader
            title={
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <IconButton onClick={() => navigate("/api-integration-engine/key-value-category")}>
                    <ArrowBack />
                  </IconButton>
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      API Engine Category Details
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                      Enter New API Engine Category Details.
                    </MaterialTypography>
                  </Stack>
                </Stack>
              </Stack>
            }
            />
            <CardContent>
              <Grid2 container spacing={1} alignItems="center">
                  <Grid2 size={{ xs: 12, sm: 6 }}>
                      <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      >
                      Category Name*
                      </MaterialTypography>
                      <MaterialInput
                          name="categoryName"
                          placeholder="eg. category name"
                          value={formData.categoryName}
                          onChange={handleChange}
                          error={formData.categoryNameStatus === "error" ? true : false}
                          success={formData.categoryNameStatus === "success" ? true : false}
                          disabled={pageMode === "view"}
                      />
                      {formData.categoryNameStatus === "error" && (
                          <FormControl error>
                          <FormHelperText>
                              Name should be maximum 20 characters long and can contain
                              only alphabets
                          </FormHelperText>
                          </FormControl>
                      )}
                  </Grid2>
  
                  <Grid2 size={{ xs: 12, sm: 6 }}>                    
                      <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      >
                      Category Code*
                      </MaterialTypography>
                      <MaterialInput
                          name="code"
                          placeholder="eg. category code"
                          value={formData.code}
                          onChange={handleChange}
                          error={formData.codeStatus === "error" ? true : false}
                          success={formData.codeStatus === "success" ? true : false}
                          disabled={pageMode === "view"}
                      />
                      {formData.codeStatus === "error" && (
                          <FormControl error>
                          <FormHelperText>
                              Category Code must contain only uppercase letters (A-Z) and
                              underscores (_)
                          </FormHelperText>
                          </FormControl>
                      )}
                  </Grid2>
  
                  <Grid2 size={{ xs: 12, sm: 6 }}>
                      <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      >
                      Description
                      </MaterialTypography>
                      <MaterialInput
                          name="description"
                          placeholder="eg. category description"
                          value={formData.description}
                          onChange={handleChange}
                          error={formData.descriptionStatus === "error" ? true : false}
                          success={formData.descriptionStatus === "success" ? true : false}
                          disabled={pageMode === "view"}
                      />
                      {formData.descriptionStatus === "error" && (
                          <FormControl error>
                          <FormHelperText>
                              Description should be maximum 100 characters long and can
                              contain only alphabets
                          </FormHelperText>
                          </FormControl>
                      )}
                  </Grid2>
  
                  <Grid2 size={{ xs: 12, sm: 6 }}>
                      <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      >
                      Parent Key
                      </MaterialTypography>
                      <MaterialSelect
                          name="parentCategoryId"
                          value={formData.parentCategoryId}
                          options={parentKeyDropOptions}
                          onChange={handleChange}
                          error={formData.parentCategoryIdStatus === "error" ? true : false}
                          success={formData.parentCategoryIdStatus === "success" ? true : false}
                          isDisabled={pageMode === "view"}
                      />
                  </Grid2>
  
                  <Grid2 size={{ xs: 12, sm: 2 }}>
                      <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      >
                      Active
                      </MaterialTypography>
                      <FormControlLabel
                          control={
                          <Switch
                              name="isActive"
                              checked={formData.isActive}
                              onChange={(event) =>
                              handleChange({
                                  target: {
                                  name: "isActive",
                                  value: event.target.checked,
                                  },
                              })
                              }
                              color="primary"
                          />
                          }
                          label={
                          <MaterialTypography variant="caption" fontWeight="bold">
                              {formData?.isActive ? "Active" : "Inactive"}
                          </MaterialTypography>
                          }
                          sx={{ marginLeft: 0 }}
                          disabled={pageMode === "view"}
                      />
                  </Grid2>
              </Grid2>
            </CardContent>
            <MaterialBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            >
                {pageMode !== "view" && (
                <>
                    <MaterialButton
                    sx={{ m: 2 }}
                    variant="outlined"
                    color="dark"
                    onClick={() => navigate("/api-integration-engine/key-value-category")}
                    >
                    Cancel
                    </MaterialButton>
                    <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={handleSubmitApiCategory}
                    >
                    {pageMode === "edit" ? "Update" : "Submit"}
                    </MaterialButton>
                </>
                )}
            </MaterialBox>
    </DashboardLayout>
  )
}

export default ApiCategoryForm